import { SweepstakeOptions } from '@coin-microservices/sweepstakes-react-hooks'
import { makeContext } from './makeContext'

export const SweepstakesEntrySelected = makeContext<SweepstakeOptions | null>(
  null,
  'entry_selected',
)
